import { Component, OnInit, Input, OnDestroy ,Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';


import Swal from 'sweetalert2'

// modales
import { FormIngresos } from 'app/finanzas/modals/form-bitacora/ingresos/form-ingresos.component';
import { FormGastos } from 'app/finanzas/modals/form-bitacora/gastos/form-gastos.component';
import { ConsultaFechaComponent } from 'app/finanzas/modals/consultaFecha/consultaFecha.component';

// servicio
import { FinanzasService } from 'app/finanzas/finanzas.service';


// entidades
import { Empresa,  Bitacora, Query, Meses } from 'app/finanzas/entidades';



export class operacion { 
  resultado : any ; 
} 

@Component({
  selector: 'app-movimientos',
  templateUrl: './movimientos.component.html',
  styleUrls: ['./movimientos.component.css']
})
export class MovimientosComponent implements OnInit {

  movimiento: Bitacora = new Bitacora();
  id_empresa: number;


  g:number=1;            // variable de # paginador
  p:number=1;            // variable de # paginador

  diff: Number;            // variable que guarda el total global la diferencia entre ingresos y gastos
  f: Date;

  mes: number;            // mes que llega de la consulta del modal empresa-meses
  anio: number;          // año que llega de la consulta del modal empresa-meses 


  public meses: Array<Meses>;      
  public areas: any;     // Array que guarda los datos que vienen del servicio getArea
  public puc:   any;       // Array que guarda la tabla puc que viene del servicio getPuc
  public ingresos: Array<Bitacora> ;  // Array que trae de la tabla bitacora los movimientos tipo ingreso
  public gastos: Array<Bitacora>;     // Array que trae de la tabla bitacora los movimientos tipo gasto 
  public empresa: Empresa;  // 
  public nombre_empresa: any;   // Obtiene del servicio una empresa 

  diferenciaCE_MC: any
  mes_mostrar: any;
  idEmpresa : any;

  
  
  constructor(public dialog: MatDialog , private servicio: FinanzasService,  private route:ActivatedRoute ) { 
      

    this.ingresos = [];
    this.gastos = []; 
    this.empresa = new Empresa();
    this.f = new Date(); 
    
    this.route.queryParams
      .subscribe((params) => { 
          this.id_empresa = params.empresa;
          this.anio = params.anio;
          this.mes = params.mes;
      })  
  }
  
  ngOnInit() {  
    
    this.movimientos();
    this.tablaArea();
    this.tablaPuc();
    this.tablaEmpresas();
    this.mostrar_mes();
    this.diferenciaCE();
  }


    private movimientos() {
      this.servicio.filtro_mto_empresa(this.id_empresa, this.anio, this.mes)
        .subscribe( ( { ingresos, gastos } ) => {
          this.ingresos  = ingresos;
          this.gastos= gastos;
        });
    }

    private tablaArea(){ this.servicio.getArea()
      .subscribe( ( resp )  => {
        this.areas = resp;
      }) 
    }

    private diferenciaCE(){
      this.servicio.diferencia1(this.id_empresa, this.anio, this.mes )
        .subscribe( (  [resp] : Array<operacion>  )  => { 
          this.diferenciaCE_MC = resp.resultado 
      });
    }

    private tablaEmpresas(){  this.servicio.getEmpresaId(this.id_empresa)
      .subscribe( ( [ resp ]:Array<Empresa>  ) => {
        this.idEmpresa = resp.id_empresa;
        this.nombre_empresa = resp.Empresa; 
      })
    }

    private mostrar_mes(){  this.servicio.getMeses(this.mes)
      .subscribe( (  [ resp ]: any   ) => { 
        this.mes_mostrar = resp.nombre_mes;  
      }) 
    }


    private tablaPuc() {this.servicio.getPuc(this.id_empresa).
        subscribe( ( resp  ) => {
          this.puc = resp  
      }) 
    }

    AbrirModal(): void {
      const dialogRef = this.dialog.open(ConsultaFechaComponent, {
        width: '450px',
        data: {
          
          empresa: this.id_empresa,
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        
        this.ngOnInit()
      });
    }

    form_bitacora_ingresos(id_gasto): void {
      const dialogRef = this.dialog.open(FormIngresos, {
        width: '500px',
        data : {
          arg0: undefined,
          id_gasto : id_gasto,
          ingresos: this.ingresos,
          empresa: this.id_empresa, 
          areas: this.areas, 
          puc: this.puc,
          anio: this.anio,
          mes : this.mes,
          
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.movimiento = result;
        this.guardar();
      });
    }

    form_bitacora_gastos(id_gasto): void {
      const dialogRef = this.dialog.open(FormGastos, {
        width: '500px',
        data :{
          arg0: undefined,
          id_gasto, 
          empresa: this.id_empresa,
          gastos: this.gastos,    
          areas:this.areas,
          puc: this.puc,
          anio: this.anio,
          mes : this.mes,
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        
        this.movimiento = result;
        console.log(this.movimiento)
        this.guardar();
      });
    }

  
    guardar() {   
      if (this.movimiento['id_gasto'] != undefined){
          this.servicio.actualizarRegistro(this.movimiento, this.movimiento['id_gasto'])
              .subscribe(  ( status:Query) => {
              const affectedRows = status.affectedRows
              if( affectedRows != 0){
                Swal.fire({
                  type: 'success',
                  title: 'El registro fue actualizado'
                })
              }
              else{ 
                Swal.fire({
                  type: 'error',
                  title: 'El registro no se pudo guardar',
                })
              }
              this.servicio.filtro_mto_empresa(this.id_empresa, this.anio, this.mes)
              .subscribe( ( { ingresos, gastos }:any ) => {
                this.ingresos = ingresos;
                this.gastos= gastos;
                this.diferenciaCE();
              }); 
        })
      }
      else {
        this.servicio.insertarRegistro(this.movimiento)
            .subscribe( (status: Query) => {
              const id_insert = status.insertId; 
              if( id_insert != 0  ){
                Swal.fire({
                  type: 'success',
                  title: 'Registro Guardado',
                })
                this.servicio.filtro_mto_empresa(this.id_empresa, this.anio, this.mes)
                  .subscribe( ( { ingresos, gastos }:any ) => {
                    this.ingresos  =ingresos;
                    this.gastos= gastos;
                    this.diferenciaCE();
                  });
            }  
            else{
              Swal.fire({
                type: 'error',
                title: 'El registro no se pudo guardar',
              })
            }
        });
      } 
    }

    eliminarRegistro( ingreso? , gasto? ){
      
      Swal.fire({
        title: '¿Esta seguro que desea eliminar este registro?',
        type: 'warning',
        showCancelButton:true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si'
        
      }).then((result) => {
        
        if (result.value) {
          Swal.fire(
            'Eliminado',
            'El archivo fue eliminado correctamente',
            'success'
          )
  
          if(ingreso){ this.movimiento = ingreso}
          if(gasto ){ this.movimiento = gasto}
          this.movimiento['estado'] = 0;
          this.servicio.borrarBitacora(this.movimiento, ingreso.id_gasto).subscribe( (resp) => {
            this.servicio.filtro_mto_empresa(this.id_empresa, this.anio, this.mes)
            .subscribe( ( { ingresos, gastos } ) => {
              this.ingresos  = ingresos;
              this.gastos= gastos;
              this.diferenciaCE();
          });
  
          })
        }
      })
    }

    calcGastos() {
      return this.gastos.map(t => t.valor).reduce((acc, value) => acc + value, 0);
    }

    calcIngresos() {
      return this.ingresos.map(t => t.valor).reduce((acc, value) => acc + value, 0);
      
    }

    diferencia(){
      return  this.calcIngresos() - this.calcGastos()
    }
  

    public verificar_mes() {
      let mes_presente = this.f.getMonth() + 1;   
      let año_presente = this.f.getFullYear();
      if( this.anio < año_presente){
        return true;
      }
      else if( this.anio == año_presente && this.mes <= mes_presente ){
        return true;
      }
      return false;
    }

  }




